import {
  Coffee,
  UtensilsCrossed,
  Pizza,
  Beef,
  CupSoda,
  Croissant,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export type PosCategory = {
  id: string;
  name: string;
  searchTerms: string[];
  icon?: LucideIcon;
};

export const POS_CATEGORIES: PosCategory[] = [
  {
    id: "all",
    name: "All Menu",
    searchTerms: [],
    icon: UtensilsCrossed,
  },
  {
    id: "drinks",
    name: "Drinks",
    searchTerms: ["drink", "juice", "tea", "soda", "water", "beverage"],
    icon: CupSoda,
  },
  {
    id: "coffee",
    name: "Coffee",
    searchTerms: ["coffee", "espresso", "latte", "americano", "cappuccino", "mocha"],
    icon: Coffee,
  },
  {
    id: "japanese",
    name: "Japanese",
    searchTerms: ["japanese", "sushi", "ramen", "teriyaki", "tempura"],
    icon: UtensilsCrossed,
  },
  {
    id: "khmer",
    name: "Khmer Food",
    searchTerms: ["khmer", "cambodian", "lok lak", "amok"],
    icon: UtensilsCrossed,
  },
  {
    id: "pizza",
    name: "Pizza",
    searchTerms: ["pizza", "pizza &"],
    icon: Pizza,
  },
  {
    id: "roast",
    name: "Roast",
    searchTerms: ["roast", "roaster", "grilled"],
    icon: Beef,
  },
  {
    id: "steak",
    name: "Steak",
    searchTerms: ["steak", "beef"],
    icon: Beef,
  },
  {
    id: "bakery",
    name: "Bakery",
    searchTerms: ["bakery", "croissant", "bread", "pastry"],
    icon: Croissant,
  },
];
